import React, { Component } from "react";
import Comment from "./Comment";
import "./CommentList.css";

class CommentList extends Component {
  render() {
    let commentNodes = this.props.data.map(comment => {
      return (
        <Comment
          author={comment.author}
          createdAtFormatted={comment.createdAtFormatted}
          body={comment.body}
        />
      );
    });
    return <div className="commentList">{commentNodes}</div>;
  }
}

export default CommentList;
